import { createContext } from 'react';

export const LanguageContext = createContext<{
  setLocale: (locale: string | null) => void;
  defaultLocale?: string;
  locale: string | null;
  locales: Record<string, Record<string, string>>;
} | null>(null);

export default LanguageContext;
